var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "currentColor",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.79154 0.75L9.29837 1.32713C10.4912 2.43298 11.2423 4.0078 11.2423 5.7581C11.2423 7.50839 10.4904 9.08321 9.29837 10.1891L9.79078 10.7662C10.4868 10.1308 11.0427 9.35726 11.4231 8.495C11.8034 7.63275 11.9999 6.70069 12 5.75826C12.0001 4.81584 11.8037 3.88374 11.4235 3.02143C11.0432 2.15912 10.4874 1.38553 9.79154 0.75ZM8.07301 2.76201L7.5806 3.33914C7.90185 3.65488 8.15699 4.03144 8.33113 4.44685C8.50527 4.86226 8.59493 5.3082 8.59486 5.75863C8.59479 6.20907 8.50499 6.65498 8.33072 7.07033C8.15645 7.48569 7.90119 7.86217 7.57984 8.1778L8.07225 8.75493C8.8589 7.99854 9.35132 6.93656 9.35132 5.75885C9.35132 4.58114 8.85966 3.51841 8.07301 2.76201ZM0 3.48891V8.02728H2.12093L6.05116 10.2965V1.21972L2.12093 3.48891H0ZM5.29477 2.5298V8.98639L2.32365 7.27089H0.756396V4.2453H2.32365L5.29477 2.5298Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.50dfee6e741b80e99000680d0b1ebf69.svg";
export { ForwardRef as ReactComponent };